module.exports = __webpack_public_path__ + "img/tech3.bfa1f7b2.jpg";